import { render, staticRenderFns } from "./PaymentMethodeAdd.vue?vue&type=template&id=bfd358be&scoped=true&"
import script from "./PaymentMethodeAdd.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd358be",
  null
  
)

export default component.exports